import { supabase } from '../lib/supabase'
import { User } from '../types'

export interface AuditEntry {
  id: string
  actor_user_id: string | null
  actor_name: string | null
  action: string
  target_user_id: string | null
  target_name: string | null
  details: Record<string, any>
  created_at: string
}

export const auditService = {
  /** Append an audit entry. Non-throwing — auditing must never block the action. */
  async log(
    actor: User | null,
    action: string,
    opts: { targetUserId?: string | null; targetName?: string | null; details?: Record<string, any> } = {}
  ): Promise<void> {
    try {
      await supabase.from('audit_log').insert([
        {
          actor_user_id: actor?.id ?? null,
          actor_name: actor?.full_name ?? null,
          action,
          target_user_id: opts.targetUserId ?? null,
          target_name: opts.targetName ?? null,
          details: opts.details ?? {},
          created_at: new Date().toISOString(),
        },
      ])
    } catch (e) {
      console.error('Audit log failed (non-blocking):', e)
    }
  },

  async list(range?: { from?: string; to?: string }): Promise<AuditEntry[]> {
    let q = supabase.from('audit_log').select('*').order('created_at', { ascending: false }).limit(200)
    if (range?.from) q = q.gte('created_at', range.from)
    if (range?.to) q = q.lte('created_at', range.to + 'T23:59:59Z')
    const { data, error } = await q
    if (error) throw error
    return (data || []) as AuditEntry[]
  },
}
